export default "__VITE_ASSET__BKv31vXz__"